import React from 'react'
import {Alert, Button, Col, Form, Row, Table} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import Moment from 'react-moment'
import 'moment-timezone'
import AdminMainContainer from '../components/AdminMainContainer'
import Message from '../components/Message'
import {AUTONOMO, COLABORADOR, EMPREENDEDOR, LIDER} from '../constants/categoryConstants'

const AdminAnswersList = ({
                              handlePrintSelected,
                              selectedAnswers,
                              printLoading,
                              answers,
                              printError,
                              handleSelectAllChange,
                              error,
                              allSelected,
                              handleCheckboxChange,
                              selectAnswers,
                              indeterminate,
                              handleFetchAllAnswers, // new prop
                              fetchAllLoading, // new prop
                              fetchAllProgress // new prop
                          }) => {

    return (
        <AdminMainContainer>
            <Row>
                <Col>
                    <h1>Respostas</h1>
                </Col>

                <Col className="text-right">
                    <div className="d-flex justify-content-end gap-2">
                        <Button
                            onClick={handlePrintSelected}
                            className="d-print-none"
                            disabled={selectedAnswers.length === 0 || printLoading}
                        >
                            <i className="fas fa-print"></i> {printLoading ? 'Carregando...' : 'Imprimir Selecionados'}
                        </Button>
                        <Button
                            onClick={handleFetchAllAnswers}
                            className="d-print-none"
                            disabled={fetchAllLoading}
                            variant="outline-primary"
                        >
                            {fetchAllLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2 mr-1" role="status" aria-hidden="true"> </span>
                                    Carregando...
                                </>
                            ) : 'Mostrar todas respostas'}
                        </Button>
                    </div>
                </Col>
            </Row>
            {answers.length === 0 && (
                <Message variant="primary">Ainda não houveram respostas</Message>
            )}
            {printError && <Alert variant="danger">{printError}</Alert>} {/* Use Alert for printError */}
            {error && <Message variant="danger">{error}</Message>}
            <div className="responsesTable">
                <Table striped bordered hover>
                    <thead>
                    <tr>
                        <th rowSpan={2} className="text-center align-middle">
                            <Form.Check
                                type="checkbox"
                                onChange={handleSelectAllChange}
                                checked={allSelected}
                                ref={input => { if (input) input.indeterminate = indeterminate }}
                            /></th>
                        <th
                            rowSpan={2}
                            colSpan={3}
                            className="text-center align-middle d-none d-print-table-cell"
                        ></th>
                        <th
                            rowSpan={2}
                            className="text-center align-middle d-print-none"
                        >
                            Nome
                        </th>
                        <th
                            rowSpan={2}
                            className="text-center align-middle d-print-none"
                        >
                            Email
                        </th>
                        <th
                            rowSpan={2}
                            className="text-center align-middle d-print-none"
                        >
                            Finalizado
                        </th>
                        <th
                            rowSpan={2}
                            className="text-center align-middle d-print-none"
                        >
                            N&#186; respostas
                        </th>
                        <th
                            rowSpan={2}
                            className="text-center align-middle d-print-none"
                        >
                            1&#170; Tentativa
                        </th>
                        <th rowSpan={2} className="text-center align-middle">
                            Iniciado em
                        </th>
                        <th colSpan={4} className="text-center align-middle">
                            Resultados
                        </th>
                        <th rowSpan={2} className="d-print-none"></th>
                    </tr>
                    <tr>
                        <th className="text-center align-middle">Empreendedor</th>
                        <th className="text-center align-middle">Autônomo</th>
                        <th className="text-center align-middle">Líder</th>
                        <th className="text-center align-middle">Colaborador</th>
                    </tr>
                    </thead>
                    <tbody>
                    {selectAnswers().map((answer) => (
                        <tr key={answer.id}>
                            <td className="align-middle text-center">
                                <Form.Check
                                    type="checkbox"
                                    checked={selectedAnswers.includes(answer.id)}
                                    onChange={() => handleCheckboxChange(answer.id)}
                                />
                            </td>

                            <td
                                colSpan={3}
                                className="align-middle d-none d-print-table-cell"
                            >
                                <strong>Nome:</strong> {answer.name}
                                <br/>
                                <strong>Email:</strong> {answer.email}
                                <br/>
                                <strong>Finalizado:</strong>{' '}
                                {!answer.completed ? (
                                    <i className="fas fa-times text-danger"></i>
                                ) : (
                                    <i className="fas fa-check text-success"></i>
                                )}
                                <br/>
                                <strong>N&#186; respostas:</strong>{' '}
                                <span
                                    className={answer.answer_count > 1 ? 'text-danger' : ''}
                                >
                      {answer.answer_count}
                    </span>
                                <br/>
                                <strong>1&#170; Tentativa:</strong>{' '}
                                {answer.is_first_try ? (
                                    <i className="fas fa-check text-success"></i>
                                ) : (
                                    <i className="fas fa-times text-danger"></i>
                                )}
                                <br/>
                            </td>
                            <td className="align-middle d-print-none">{answer.name}</td>
                            <td className="align-middle d-print-none">{answer.email}</td>
                            <td className="align-middle d-print-none">
                                {answer.completed ? (
                                    <i className="fas fa-check text-success"></i>
                                ) : (
                                    <i className="fas fa-times text-danger"></i>
                                )}
                            </td>
                            <td
                                className={`align-middle d-print-none ${
                                    answer.answer_count > 1 && 'text-danger'
                                }`}
                            >
                                {answer.answer_count}
                            </td>
                            <td className="align-middle d-print-none">
                                {answer.is_first_try ? (
                                    <i className="fas fa-check text-success"></i>
                                ) : (
                                    <i className="fas fa-times text-danger"></i>
                                )}
                            </td>
                            <td className="align-middle text-left">
                                <Moment format="DD/MM/YYYY HH:mm" tz="America/Sao_Paulo">
                                    {answer.created_at}
                                </Moment>
                            </td>
                            <td className="align-middle text-left">
                                {answer.results[EMPREENDEDOR]}
                            </td>
                            <td className="align-middle text-left">
                                {answer.results[AUTONOMO]}
                            </td>
                            <td className="align-middle text-left">
                                {answer.results[LIDER]}
                            </td>
                            <td className="align-middle text-left">
                                {answer.results[COLABORADOR]}
                            </td>
                            <td className="d-print-none align-middle">
                                <Link to={`/admin/answers/${answer.id}`} target="_blank">
                                    Resultado
                                </Link>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        </AdminMainContainer>
    )
}

export default AdminAnswersList

